import React, { forwardRef, Ref } from "react";

import classnames from "classnames";

import { StyledTextarea } from "./Styles";
import { InputMode } from "../Input/types";

export interface TextareaProps {
  invalid?: boolean;
  mode?: InputMode;
}

export const Textarea = forwardRef(
  (
    {
      className,
      disabled = false,
      invalid = false,
      mode = "outlined",
      ...rest
    }: TextareaProps &
      Omit<React.ComponentPropsWithoutRef<"textarea">, keyof TextareaProps>,
    ref: Ref<HTMLTextAreaElement> | null | undefined
  ) => {
    return (
      <StyledTextarea
        {...rest}
        $invalid={invalid}
        ref={ref}
        $mode={mode}
        disabled={disabled}
        aria-invalid={invalid}
        className={classnames(
          "c-textarea",
          { "c-textarea__disabled": disabled },
          className
        )}
      />
    );
  }
);

Textarea.displayName = "Textarea";
